import * as Immutable from "immutable";
import RecordClassCreator from "services/record";

export default class Chatter extends RecordClassCreator({
  type: "chatter",

  /** @memberof Chatter# */
  agents: Immutable.List(),

  /** @memberof Chatter# */
  created: null,

  /** @memberof Chatter# */
  clientToken: null,

  /** @memberof Chatter# */
  clientTokens: Immutable.List(),

  /** @memberof Chatter# */
  csatScore: Immutable.Map(),

  /** @memberof Chatter# */
  email: null,

  /** @memberof Chatter# */
  lastInteraction: null,

  /** @memberof Chatter# */
  online: null,

  /** @memberof Chatter# */
  responses: Immutable.List(),

  /** @memberof Chatter# */
  state: null,

  /** @memberof Chatter# */
  storage: Immutable.Map(),

  /** @memberof Chatter# */
  token: null,

  /** @memberof Chatter# */
  updated: null
}) {
  /**
   * @param {Object} payload
   * @returns {Object}
   */
  static resolveFetchOneResult(payload) {
    return {
      data: payload.chatter
    };
  }

  /**
   * @param {Object} payload
   * @returns {Object}
   */
  static resolveFetchManyResult(payload) {
    return {
      data: payload.chatters
    };
  }

  /**
   * @returns {String}
   */
  get nameToRender() {
    if (this.storage.get("name")) {
      return this.storage.get("name");
    }

    if (this.storage.get("phone")) {
      return this.storage.get("phone");
    }

    if (this.storage.get("phoneNumber")) {
      return this.storage.get("phoneNumber");
    }

    if (this.email) {
      return this.email;
    }

    if (this.storage.get("testUser")) {
      return "Test User";
    }

    return "Anonymous";
  }
}
